export const oraleTaqueroMetalBackground = {
    backgroundColor: '#34393e',
    backgroundImage: [
        'repeating-linear-gradient(0deg, rgba(255, 255, 255, 0.035) 0px, rgba(255, 255, 255, 0.035) 1px, rgba(0, 0, 0, 0.045) 1px, rgba(0, 0, 0, 0.045) 2px, transparent 2px, transparent 4px)',
        'linear-gradient(90deg, #303438 0%, #43484d 18%, #34393e 40%, #2c3035 62%, #3d4247 82%, #303438 100%)'
    ].join(', ')
}
